export const copiasColumns = [
  { field: "id", headerName: "ID", width: 275 },
  {
    field: "idLibro",
    headerName: "Libro ID",
    width: 275,
  },
  {
    field: "estado",
    headerName: "Estado",
    width: 275,
  }
];